import React from 'react';

import './assets/scss/themes.scss';
import './index.css';

import Route from './Routes';
import { AuthProvider } from './Components/AuthContext';
import { DialogProvider } from './Components/Common/DialogProvider';
import { DIALOG_TOASTER_ID } from './utils/dialogService';
import {
  useQuery,
  useMutation,
  useQueryClient,
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: true,
      retry: 2,
    },
  },
})

import ErrorBoundary from './Components/Common/ErrorBoundary';

function App() {
  return (
    <React.Fragment>
      <QueryClientProvider client={queryClient}>
        <ErrorBoundary>
          <DialogProvider>
            <AuthProvider>
              <Route />
            </AuthProvider>
            <Toaster toasterId={DIALOG_TOASTER_ID} position="top-center" />
          </DialogProvider>
        </ErrorBoundary>
      </QueryClientProvider>
    </React.Fragment>
  );
}

export default App;
